import React from "react";
import PropTypes from "prop-types";
import styles from "./ArrowLinkButton.module.css";

function ArrowLinkButton({ children, className = "", onClick, type = "button" }) {
  const classes = className ? `${styles.button} ${className}` : styles.button;

  return (
    <button className={classes} onClick={onClick} type={type}>
      <span>{children}</span>
      <span className={styles.arrow}>&rarr;</span>
    </button>
  );
}

ArrowLinkButton.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  type: PropTypes.oneOf(["button", "submit", "reset"]),
};

export default ArrowLinkButton;
